<!-- Section navigation of the dev-only UI kit, drawn like the Pulso side menu. -->
<nav class="kit-menu" aria-label="UI kit">
	<div class="kit-menu__marca">
		<img [src]="logo()" alt="" />
		<span>UI kit</span>
	</div>
	@for (item of modelUpper; track item.id) {
		<button type="button" class="kit-menu__item" [class.kit-menu__item--on]="isActive(item.id)" (click)="handleMenuItemClick(item)">
			<lucide-icon [name]="item.icon" [size]="18"></lucide-icon>
			{{ item.label }}
		</button>
	}
</nav>
